import { useState } from "react";
import "./ResetPassword.css";
import logo from "../../../../assets/img/topbar/logo.png";
import "react-toastify/dist/ReactToastify.css"; // Import the Toastify CSS
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { Navbar } from "../../../WebUi/Components/HomeV2/Navbar";
import { Footer } from "../../../WebUi/Footer/Footer";

export const KidSetPassword = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [usernameValid, setUsernameValid] = useState(true);

  const [password_confirmation, setConfirmPassword] = useState("");
  const [passwordmatch, setpasswordmatch] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false); // Toggle for current password visibility
  const [showNewPassword, setShowNewPassword] = useState(false); // Toggle for new password visibility
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsername(e.target.value);
    const trimmedValue = value.trim();

    // Check for length >= 5 and no spaces
    if (trimmedValue.length < 5 || /\s/.test(value)) {
      setUsernameValid(false);
    } else {
      setUsernameValid(true);
    }
  };
  const isValidPassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(password);

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    setPasswordValid(isValidPassword(newPassword));

    // If password_confirmation already typed, recheck match
    if (password_confirmation) {
      setpasswordmatch(password_confirmation === newPassword);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const confirmPasswordValue = e.target.value;
    setConfirmPassword(confirmPasswordValue);
    setpasswordmatch(confirmPasswordValue === password);
  };

  const handleSubmit = async () => {
    let valid = true;

    setPasswordValid(true);
    setpasswordmatch(true);
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!passwordRegex.test(password)) {
      setPasswordValid(false);
      valid = false;
    }
    if (!usernameValid) {
      valid = false;
      return;
    }
    // Confirm password
    if (password !== password_confirmation) {
      setpasswordmatch(false);
      valid = false;
    }
    if (valid) {
      try {
        const formData = new FormData();
        formData.append("password", password);
        formData.append("password_confirmation", password_confirmation);
        formData.append("email", email);
        formData.append("token", token);
        if (username !== "") {
          formData.append("username", username);
        }
        const response = await fetch(`${apiUrl}/kids/set-password`, {
          method: "POST",

          body: formData,
        });

        if (response.ok) {
          toast.success("Password updated successfully!");
          navigate("/");
        } else {
          const error = await response.json();
          toast.error(error.message || "Failed to update password.");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      }
    }
  };

  return (
    <>
      <div>
        <Navbar />
      </div>
      <section className="LoginCard">
        <div className="container">
          <div className="row">
            <div className="col-lg-3"></div>
            <div className="col-lg-6">
              <form className="LoginInrCard" onSubmit={handleSubmit}>
                <div className="text-center">
                  <img className="img-fluid" src={logo} alt="logo" />
                  <p className="mt-4 mb-1">Welcome Back!</p>
                  <p className="LoginCardTitle">Reset your password</p>
                </div>
                <div>
                  {/* <p className="DelModalTitl">Edit {kid.name}</p> */}
                  <form>
                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">
                        Username
                      </label>
                      <input
                        type={"text"}
                        className={`form-control `}
                        id="username"
                        onChange={handleUsernameChange}
                        value={username}
                        maxLength={15}
                      />
                      {!usernameValid && (
                        <div className="invalid-feedback d-block">
                          Username length must be more than 5 character and no
                          space allowed
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={showCurrentPassword ? "text" : "password"}
                          className={`form-control ${
                            !passwordValid
                              ? "is-invalid no-validation-icon"
                              : ""
                          }`}
                          id="password"
                          onChange={handlePasswordChange}
                          value={password}
                          required
                        />
                        <span
                          className="position-absolute top-50 translate-middle-y"
                          style={{ right: "15px", cursor: "pointer" }}
                          onClick={() =>
                            setShowCurrentPassword((prevState) => !prevState)
                          }
                        >
                          <i
                            className={`fa ${
                              showCurrentPassword ? "fa-eye" : "fa-eye-slash"
                            }`}
                          ></i>
                        </span>
                      </div>

                      {!passwordValid && (
                        <div className="invalid-feedback  d-block">
                          Password must be at least 8 characters long and
                          contain at least one uppercase letter, one lowercase
                          letter, one number, and one special character.
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="password_confirmation"
                        className="form-label"
                      >
                        Confirm Password
                      </label>
                      <div className="position-relative">
                        <input
                          type={showNewPassword ? "text" : "password"}
                          className={`form-control ${
                            !passwordmatch
                              ? "is-invalid no-validation-icon"
                              : ""
                          }`}
                          id="password_confirmation"
                          onChange={handleConfirmPasswordChange}
                          value={password_confirmation}
                          required
                        />
                        <span
                          className="position-absolute top-50 translate-middle-y"
                          style={{ right: "15px", cursor: "pointer" }}
                          onClick={() =>
                            setShowNewPassword((prevState) => !prevState)
                          }
                        >
                          <i
                            className={`fa ${
                              showNewPassword ? "fa-eye" : "fa-eye-slash"
                            }`}
                          ></i>
                        </span>
                      </div>
                      {!passwordmatch ? (
                        <div className="invalid-feedback d-block">
                          Passwords do not match
                        </div>
                      ) : null}
                    </div>
                  </form>
                  <Button
                    className="btn btn-primary mt-4 w-100 kidRegistrSubmtBtn"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </div>
            <div className="col-lg-3"></div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
